import { ImmutableArray, ImmutableObject, State } from "@hookstate/core"
import { Validation } from "@hookstate/validation"
import React, { useState } from "react"
import ModalBS from "react-bootstrap/Modal"
import { styled } from "styled-components"
import { NotificationTemplatePackage } from "."
import branding from "../../branding/branding"
import RadioField from "../../components/Field/Radio"
import Modal, { CancelButton, OkButton } from "../../components/Modal"
import { ServiceKeys } from "../../globalStates/ConfigDataState"
import { NotificationTemplate } from "../../globalStates/ExhibitorDataTypes"
import { useLanguageState } from "../../globalStates/LanguageState"
import { SubelementPackage } from "../../globalStates/SubelementPackagesState"
import { getElementLocalizedName } from "../../globalStates/utils"

interface PackageModalProps {
    visible: boolean
    onOk: (packageForAdding: NotificationTemplatePackage) => void
    onClose: () => void
    labelOk?: string
    labelClose?: string
    notificationTemplatesStates: State<ImmutableArray<NotificationTemplate>, Validation>
    subelementPackages: ImmutableArray<SubelementPackage>
    serviceKeys: ServiceKeys
}

const PackageListContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px 0 0 10px;
`

const PackageItemContainer = styled.div`
    display: flex;
    position: relative;
    padding-bottom: 10px;
`

const NotificationTemplatePackageModal: React.FC<PackageModalProps> = ({
    visible,
    onOk,
    onClose,
    notificationTemplatesStates,
    subelementPackages,
    serviceKeys
}) => {
    const lang = useLanguageState().getLanguage()
    const [packageForAdding, setPackageForAdding] = useState<NotificationTemplatePackage>()

    function displayPackage(shopPackage: ImmutableObject<SubelementPackage>): boolean {
        const shopPackageId = shopPackage.id as NotificationTemplatePackage

        if (!(serviceKeys[shopPackageId] && serviceKeys[shopPackageId]! > 0)) return false

        if (getNumberOfNotificationsPerPackage(shopPackageId) >= serviceKeys[shopPackageId]!) return false

        return true
    }

    function getNumberOfNotificationsPerPackage(shopPackage: NotificationTemplatePackage): number {
        return (notificationTemplatesStates?.filter(
            (notificationTemplatesState) => notificationTemplatesState.subelementPackage.get() === shopPackage
        )).length
    }

    return (
        <Modal
            title={branding.configuration.notificationTemplatesPage.sctNotificationTemplates.lblPackageModalTitle}
            name="packageModal"
            visible={visible}
            onClose={onClose}
        >
            <ModalBS.Body>
                <div>{branding.configuration.notificationTemplatesPage.sctNotificationTemplates.lblPackageModalDescription}</div>

                <PackageListContainer>
                    {subelementPackages.map((item) => {
                        if (!displayPackage(item)) return null

                        return (
                            <PackageItemContainer>
                                <RadioField
                                    id={item.id}
                                    name={getElementLocalizedName(item, lang, "name")}
                                    value={packageForAdding ?? ""}
                                    radioValue={item.id}
                                    label={`${getElementLocalizedName(
                                        item,
                                        lang,
                                        "name"
                                    )} (${branding.configuration.notificationTemplatesPage.sctNotificationTemplates.msgCriteriaList
                                        .replace(
                                            "{$selected}",
                                            getNumberOfNotificationsPerPackage(item.id as NotificationTemplatePackage).toString()
                                        )
                                        .replace(
                                            "{$total}",
                                            (serviceKeys[item.id as NotificationTemplatePackage] || 0).toString()
                                        )})`}
                                    onChange={() => setPackageForAdding(item.id as NotificationTemplatePackage)}
                                />
                            </PackageItemContainer>
                        )
                    })}
                </PackageListContainer>
            </ModalBS.Body>
            <ModalBS.Footer>
                <CancelButton
                    name="packageModal"
                    label={branding.configuration.notificationTemplatesPage.sctNotificationTemplates.lblPackageModalCancel}
                    onCancel={onClose}
                />
                <OkButton
                    name="packageModal"
                    label={branding.configuration.notificationTemplatesPage.sctNotificationTemplates.lblPackageModalConfirm}
                    onOk={() => packageForAdding && onOk(packageForAdding)}
                />
            </ModalBS.Footer>
        </Modal>
    )
}

export default NotificationTemplatePackageModal
